/**
 * Footer Ask Layout block script.
 *
 * Reveals the inner-blocks container and staggers its children when the
 * footer-ask scrolls into view. Triggers earlier than default (amount: 0.25)
 * because the footer-ask is tall and we want the reveal to feel timely
 * rather than delayed until it's mostly on screen.
 */

import { revealStagger } from '@/motion-primitives';

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-footer-ask-layout').forEach((section) => {
		const innerBlocks = section.querySelector('.acf-innerblocks-container');
		const target = innerBlocks || section.querySelector('.container');
		if (!target) return;

		revealStagger(target, {
			stagger: 0.12,
			duration: 0.55,
			amount: 0.25,
			distance: 24,
		});
	});
});
